module.exports = "/static/media/exam_history_icon.ec6d5039.svg";